import React from "react";
import {
  Button,
  Paper,
  Table,
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  ButtonGroup,
  makeStyles,
} from "@material-ui/core";
import { FormatoFecha, FormatoFechaIso } from "../../../utils/FormatFecha";
const useStyles = makeStyles({
  root: {
    width: '100%'
  },
  container: {
    maxHeight: 250,
    margin: '25px 0'
  },
});
const TablaFechas = (props) => {
  const { rows = [], onDeleteFecha = () => { } } = props;
  const classes = useStyles();
  return (
    <TableContainer component={Paper} className={classes.container}>
      <Table size="small" stickyHeader aria-label="sticky table">
        <TableHead>
          <TableRow>
            <TableCell align="center">Fecha prevista</TableCell>
            <TableCell align="center">Disponibilidad</TableCell>
            <TableCell align="center"></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row, index) => {
            return (
              <TableRow key={index + 1}>
                <TableCell align="center">{`${FormatoFechaIso({ date: row.FechaSalida, formato: "dd/MM/yyyy" })}`}</TableCell>
                <TableCell align="center">{row.disponibilidad}</TableCell>
                <TableCell align="center">
                  <ButtonGroup
                    color="primary"
                    size="small"
                    aria-label="small outlined  button group"
                  >
                    <Button onClick={() => onDeleteFecha(row)}>Eliminar</Button>
                  </ButtonGroup>
                </TableCell>
              </TableRow>
            )
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
export default TablaFechas;
